
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import AuthHeader from "./components/auth-header.vue";
import SideLayout from "./components/SideLayout.vue";
import { Component, Vue } from "vue-property-decorator";
import Auth from "@/lib/common/auth";
import AiLogin from "@/content/aiLogin.vue";
import vuexStore from "@/store/vuex-store";

@Component({
  components: {
    SideLayout,
    AuthHeader,
    AiLogin
  }
})
// 牛人星球客户端 系统根vue  规则： 所有路由包含 -nr的 为牛人客户端
export default class HomeNr extends Vue {
  show = true; //特定页面不展示
  showCompany = false; //公司卡片
  atsCompanyOutId = "";
  nrToken = "";

  //候选人端页面 不需登录 不展示侧边栏
  get isCandidatePage() {
    return document.URL.includes("public") && !document.URL.includes("-nr");
  }

  get isNrDomain() {
    return document.URL.includes("nrpla");
  }

  get isPublicPage() {
    return document.URL.includes("public");
  }

  created() {
    this.nrToken = String(localStorage.getItem("nrToken") || "");
    console.log("nrToken:" + this.nrToken);
    this.atsCompanyOutId = String(
      localStorage.getItem("atsCompanyOutId") || ""
    );

    if (!this.nrToken && !this.isCandidatePage) {
      //未登录 去登陆
      // this.$router.replace("/login-nr?atsCompanyOutId=" + this.atsCompanyOutId);
      this.$router.replace("/public/login-nr");
      return;
    }
  }
  mounted() {
    //阅卷页面头部仅供展示
    this.show =
      this.$route.name === "paper-mark" ||
      this.$route.name === "candidate-info" ||
      this.$route.name === "paper-mark-mobile" ||
      this.$route.name === "candidates-info"
        ? false
        : true;
  }
  closeCompany() {
    vuexStore.updateShowCompany(false);
  }
}
